export default __webpack_public_path__ + "static/media/leader.949c0122.jpeg";